<template>
  <div class="contain">
    <div class="content">
      <div class="leftimg"></div>
      <div class="login">
        <el-form ref="groupForm" :model="form" :rules="rules">
          <h1>永嘉县水旱灾害防御平台</h1>
          <div class="inputBox">
            <div>
              <div class="usericon"></div>
              <el-form-item prop="userName">
                <el-input v-model="form.userName" placeholder="请输入账号"></el-input>
              </el-form-item>
            </div>
            <div>
              <div class="passwordicon" prop="password"></div>
              <el-form-item prop="password">
                <el-input
                  @keyup.enter.native="handleLogin"
                  v-model="form.password"
                  placeholder="请输入密码"
                  type="password"
                ></el-input>
              </el-form-item>
            </div>
            <div class="yzBox">
              <div class="yzicon"></div>
              <el-form-item prop="nonce" class="ver_code_input">
                <el-input v-model="form.nonce" placeholder="请输入验证码" @keyup.enter.native="handleLogin"></el-input>
              </el-form-item>
              <div class="ver_code_img">
                <img :src="codeImg" @click="getCode"/>
              </div>
            </div>
          </div>
          <el-button class="loginbtn" :loading="loading" @click="handleLogin">登 录</el-button>
        </el-form>
      </div>
    </div>
    <el-dialog width="30%" title="密码过于简单 请修改密码" :visible.sync="diagShow" :close-on-click-modal='false' class="dialog_content">
      <el-form :model="ruleForm" status-icon :rules="ruleFormRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="旧密码" prop="oldPassWord">
          <el-input type="password" v-model="ruleForm.oldPassWord" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="newPassWord">
          <el-input type="password" v-model="ruleForm.newPassWord" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" clearable></el-input>
        </el-form-item>
        <div style="text-align:center">
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import userTypes from '@/store/types/user'
import Codetest from './codetest'
import config from '@/config'
// let Base64 = require('js-base64').Base64
export default {
  name: '',
  components: {
    Codetest
  },
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.newPassWord) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      diagShow: false,
      form: {
        userName: '',
        password: '',
        nonce: ''
      },
      rules: {
        userName: [{ required: true, message: '用户名不能为空' }],
        password: [{ required: true, message: '密码不能为空' }],
        nonce: [{ required: true, message: '验证码不能为空' }]
      },
      publicKey: '',
      uid: '',
      ruleForm: {
        newPassWord: '',
        checkPass: '',
        oldPassWord: ''
      },
      ruleFormRules: {
        newPassWord: [
          { validator: this.Global.checkPassword },
          { min: 8, message: '长度不能小于8位' },
          { max: 18, message: '长度不大于18位' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        oldPassWord: [
          { required: true, message: '原密码不能为空' }
        ]
      },
      codeImg: ''
    }
  },
  methods: {
    getCode() {
      this.$axios({
        url: config.ApiYJ + '/auth/getVerifyImg',
        responseType: 'blob', // 重要
        method: 'get'
      }).then(res => {
        let blob = new Blob([res.data], { type: 'image/png' })
        let url = window.URL.createObjectURL(blob)
        this.codeImg = url
      })
    },
    showMsgFromChild (data) {},
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.Id = this.uid
          this.$store.dispatch(userTypes.CHANGE_PWD, this.ruleForm).then(() => {
            this.$notify.success({ title: '成功', message: '修改成功，请重新登录' })
            this.loading = false
            this.diagShow = false
            this.ruleForm = {}
          }).catch(() => { this.loading = false })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleLogin () {
      this.loading = true
      let jse = new this.$jsEncrypt()
      this.$store.dispatch(userTypes.Get_PUBLICKEY).then(res => {
        let sessionId = res.sessionId
        this.publicKey = res.publicKey
        jse.setPublicKey(this.publicKey)
        this.$refs['groupForm'].validate(valid => {
          if (valid) {
            this.$store
              .dispatch(userTypes.LOGIN, {
                userName: jse.encrypt(this.form.userName),
                password: jse.encrypt(this.form.password),
                nonce: this.form.nonce,
                sessionId: sessionId
              })
              .then(data => {
                this.ListMainMenu().then(res => {
                  var reg = new RegExp('(/^[0-9]+$/)')
                  if (reg.test(this.form.password)) {
                    this.uid = data.userId
                    this.diagShow = true
                    this.$refs['ruleForm'].resetFields()
                  } else {
                    this.$router.push({ name: 'meiyu' })
                  }
                  this.loading = false
                })
              })
              .catch(res => {
                this.loading = false
                this.getCode()
                const msg = res.response.data.responseStatus.message
                this.$notify.error({ title: '错误', message: msg })
              })
          } else {
            this.loading = false
            this.getCode()
          }
        })
      })
    }
  },
  mounted () {
    this.getCode()
    this.showMsgFromChild()
  }
}
</script>
<style scoped>
.contain {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(~@/assets/login/bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content {
  width: 866px;
  height: 462px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -231px;
  margin-left: -433px;
}
.leftimg {
  width: 354px;
  height: 462px;
  background-image: url(~@/assets/login/slide.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  float: left;
  position: absolute;
  margin-left: 20px;
}
.login {
  width: 507px;
  background: #fff;
  float: right;
  text-align: center;
  margin: 11px 0;
  height: 434px;
}
.login h1 {
  margin: 50px 70px 0;
  font-size: 28px;
  color: #333333;
}
.inputBox {
  height: 178px;
}
.el-form > div > div {
  display: flex;
  margin-left: 120px;
  border: 1px solid #ccc;
  height: 46px;
  margin-top: 20px;
  width: 280px;
  border-radius: 8px;
}
.el-form > div > div >>> .el-form-item__error{
  margin-top: 0px;
}
.el-form > div > div >>> .el-input__inner {
  border: none;
}
.el-form > div > div:nth-child(1) {
  margin-top: 50px;
}
.usericon {
  width: 32px;
  height: 40px;
  background: url(~@/assets/login/user.png);
  background-repeat: no-repeat;
  background-position: 5px center;
}
.passwordicon {
  width: 32px;
  height: 40px;
  background: url(~@/assets/login/password.png);
  background-repeat: no-repeat;
  background-position: 5px center;
}
.yzBox{
  position: relative;
}
.yzicon {
  width: 32px;
  height: 40px;
  background: url(~@/assets/login/code.png);
  background-repeat: no-repeat;
  background-position: 5px center;
}
.ver_code_img{
  position: absolute;
  right: 20px;
  top: 2px;
  width: 100px;
  height: 30px;
}
.loginbtn {
  margin-top: 45px;
  width: 315px;
  height: 45px;
  background: #5396fe;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
  .login {
    .el-form{
      /deep/ .el-input__inner{
        height: 44px;
        line-height: 44px;
        -webkit-box-shadow: 0 0 0 1000px white inset !important;
      }
    }
  }
  .dialog_content {
    margin-top: 21vh;
    /deep/ .el-dialog__header {
      height: 60px;
      background-image: url('~@/assets/monitorimg/opentitle.png');
      background-repeat: no-repeat;
      background-position: 18px 28px;
      background-size: 370px 17px;
      background-color: #3e6ffc;
      position: relative;
    }
    /deep/ .el-dialog__title {
      color: #fff;
      margin-left: 45px;
      display: inline-block;
      position: absolute;
      top: 17px;
    }
    /deep/ .el-dialog__headerbtn {
      display: none;
    }
    /deep/ .el-dialog__body {
      padding: 25px 15px 15px 15px;
      .el-form > div {
        height: 45px;
      }
      .el-input {
        width: 90%;
      }
    }
  }
</style>
